enum SudokuEventType {
  CANT_BE,
  NUMBER_FOUND,
}
export default SudokuEventType;
